import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp, ShieldAlert } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Props {
  className?: string;
}

export function MedicalDisclaimerBanner({ className }: Props) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      role="note"
      className={cn(
        'rounded-md border border-info/30 bg-info/5 text-foreground px-3 py-2 text-xs',
        className,
      )}
    >
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="flex w-full items-start gap-2 text-left"
        aria-expanded={expanded}
      >
        <ShieldAlert className="w-4 h-4 text-info shrink-0 mt-0.5" aria-hidden />
        <span className="flex-1 leading-snug">
          {t('medicalDisclaimer.shortBanner')}
        </span>
        {expanded ? (
          <ChevronUp className="w-4 h-4 text-muted-foreground shrink-0" aria-hidden />
        ) : (
          <ChevronDown className="w-4 h-4 text-muted-foreground shrink-0" aria-hidden />
        )}
      </button>
      {expanded && (
        <p className="mt-2 ml-6 leading-relaxed text-muted-foreground">
          {t('medicalDisclaimer.body')}
        </p>
      )}
    </div>
  );
}
